module.exports = __webpack_public_path__ + "img/1.1244a404.png";